/**
 * 작성일 : 2024-11-12
 * 작성자 : 양다빈
 * 유저 세션 저장 및 확인
 */

export const setSessionFunc = async (data) => {
  console.log(`***** setSessionFunc start *****`);
  try {
    const response = await fetch("/user/set_session", {
      method: "POST",
      mode: "cors",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        data: data,
      }),
    });

    console.log(response);
    const returnData = await response.json();
    console.log(`***** setSessionFunc *****`);
    console.log(returnData);
    console.log(`***** setSessionFunc *****`);
    if (response.status == 200) {
      return returnData;
    } else {
      // 로그인 실패 처리
      if (response.status === 401) {
      }
    }
  } catch (e) {
    console.log(`setSessionFunc Error : ${e}`);
  }
};

export const getSessionFunc = async (id) => {
  console.log(id);
  try {
    const response = await fetch("/user/get_session", {
      method: "POST",
      mode: "cors",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: id }),
    });

    const returnData = await response.json();
    console.log(`***** getSessionFunc *****`);
    console.log(returnData);
    console.log(`***** getSessionFunc *****`);
    if (response.status == 200) {
      return returnData;
    } else {
      // 로그인 실패 처리
      if (response.status === 401) {
      }
    }
  } catch (e) {
    console.log(`getSessionFunc Error : ${e}`);
  }
};

export const delSessionFunc = async (id) => {
  try {
    const response = await fetch("/user/del_session", {
      method: "POST",
      mode: "cors",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: id }),
    });

    const returnData = await response.json();
    //console.log(`***** delSessionFunc *****`);
    //console.log(returnData);
    //console.log(`***** delSessionFunc *****`);
    if (response.status == 200) {
      return returnData;
    } else {
      // 로그인 실패 처리
      if (response.status === 401) {
      }
    }
  } catch (e) {
    console.log(`getSessionFunc Error : ${e}`);
  }
};

export const loginFunc = async (id, password, domain = "antsnest") => {
  console.log(`***** loginFunc start *****`);
  console.log(`Current URL: ${window.location.href}`);
  console.log(`API URL: ${window.location.origin}/request/login`);
  console.log(`Domain: ${domain}`);
  
  try {
    const response = await fetch("/request/login", {
      method: "POST",
      mode: "cors",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        user_id: id,
        user_pwd: password,
        domain: domain
      }),
    });

    console.log(`Response status: ${response.status}`);
    console.log(`Response URL: ${response.url}`);
    
    if (response.ok) {
      // 로그인 성공 - JSON 응답
      const returnData = await response.json();
      console.log(`***** loginFunc 성공 *****`);
      console.log(returnData);
      console.log(`***** loginFunc 성공 *****`);
      
      // PC와 동일한 형태로 반환 (code: 200 추가)
      return {
        code: 200,
        result: returnData,
        ...returnData
      };
    } else {
      // 로그인 실패 - 텍스트 응답
      const errorText = await response.text();
      console.error(`Login failed: ${errorText}`);
      
      return {
        code: response.status,
        message: errorText
      };
    }
  } catch (e) {
    console.error(`loginFunc Error: ${e}`);
    console.error(`Error details:`, e);
    throw e;
  }
};
